<div data-testid="component-stat-card" [ngClass]="classes()" class="min-h-[150px] rounded flex flex-col justify-between">
  <div class="flex flex-row justify-between relative">
    <div class="flex-1 flex flex-col justify-between">
      <div
        data-testid="component-stat-card-value"
        class="flex-1 p-3 font-extrabold tracking-wide text-4xl min-w-[70%] max-w-[70%] max-h-[72px] overflow-hidden"
      >
        {{ value() }}
      </div>

      <div>
        <div data-testid="component-stat-card-stat" class="p-3 text-lg min-w-[70%] max-w-[70%] max-h-[52px] overflow-hidden">
          {{ stat() }}
        </div>
      </div>
    </div>

    <div class="absolute right-0 top-0 bottom-0 h-full w-1/3 flex justify-center items-center">
      @if (icon(); as icon) {
        <div class="icon" data-testid="component-stat-card-icon">
          <mat-icon>{{ icon }}</mat-icon>
        </div>
      }
    </div>
  </div>

  <div class="flex justify-center p-1 morelink">
    <ng-content select="[morelink]"></ng-content>
  </div>
</div>
